import { Card, Badge, Button } from '../../components/ui';
import './Medico.css';

export default function TarjetaTurnoAgenda({ turno }) {
  const esCambio = turno.estado === 'cambio';

  return (
    <Card as="article" style={esCambio ? { borderLeft: '4px solid var(--c-warning)' } : undefined}>
      <div className="medico-row">
        <div>
          <div className="medico-row-head">
            <strong style={{ fontSize: '1.05rem' }}>{turno.fecha}</strong>
            {esCambio
              ? <Badge tone="warning" dot>Cambio de fecha solicitado</Badge>
              : <Badge tone="success" dot>Confirmado</Badge>}
          </div>
          <p className="medico-muted" style={{ margin: '4px 0 0' }}>{turno.paciente} · {turno.detalle}</p>
        </div>
        <div className="medico-actions">
          {esCambio ? (
            <>
              <Button variant="accent" size="sm">Confirmar cambio</Button>
              <Button variant="dangerSoft" size="sm">Rechazar</Button>
            </>
          ) : (
            <>
              <Button variant="accent" size="sm">Marcar realizado</Button>
              <Button variant="secondary" size="sm">Solicitar cambio de fecha</Button>
              <Button variant="dangerSoft" size="sm">Cancelar</Button>
            </>
          )}
        </div>
      </div>
    </Card>
  );
}